module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "file"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("File")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('div', {
    attrs: {
      "id": "file"
    }
  }, [_c('v-server-table', {
    attrs: {
      "url": "/",
      "columns": _vm.columns,
      "options": _vm.options
    }
  })], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header col-md-2"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("List")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header col-md-8 text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 table-responsive"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d7cc759"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ListFile.vue
// module id = 1486
// module chunks = 1